import apiService from "./api";

const postService = {
  getAllPosts() {
    return apiService.get("/post/all");
  },
  getCountries() {
    return apiService.get("/post/get-country");
  },
  getAllCities() {
    return apiService.get("/post/all-cities");
  },
  // Get all messages (poruke)
  getAllMessages() {
    return apiService.get("/poruke/sve-poruke");
  },
  // Save message
  saveMessage(message) {
    return apiService.post("/poruke/sacuvaj-poruku", { message });
  },
  // Edit message
  editMessage(poruka) {
    return apiService.post("/poruke/izmeni-poruku", { poruka });
  },
  // Delete message
  deleteMessage(message) {
    return apiService.post("/poruke/obrisi-poruku", { message });
  },
  // Get post reports
  getPostReports(params) {
    return apiService.get("/post/reports", params);
  },
  // Post operations
  editPostStatus(item) {
    return apiService.post("/post/edit-status", item);
  },
  storePost(data) {
    return apiService.post("/post/store-post", data);
  },
  editPost(data) {
    return apiService.post("/post/edit-post", data);
  },
  deletePost(data) {
    return apiService.post("/post/delete-post", data);
  },
};

export default postService;
